// extracted by mini-css-extract-plugin
export default {"control":"toggleSwitch_control__POIzP","track":"toggleSwitch_track__3Y6r+","active":"toggleSwitch_active__LRULj","text":"toggleSwitch_text__dcrLh"};